import React, { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useBOMStore } from 'src/hooks/bom';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import System from "../../../helper/system";
import { isArray } from "underscore";
import Bom from "@system/config/bom";
import liveAuth from 'src/helper/liveAuth';
import CartRepository from "../../../repository/CartRepository";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Constants from 'src/support/Constants';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMProjectStore } from "src/hooks/bom_project";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';

window.openBOM = () => {
    localStorage.setItem("adobeEventType", "bomOpened");
}
const AddToBOMPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [status, SetStatus] = useState(false);
    const [bomName, setBomName] = useState('');
    const [bomNameStatus, setBomNameStatus] = useState(true);
    const [bomListStatus, setBomListStatus] = useState(true);
    const [optionsSearchInput, setOptionsSearchInput] = useState('');
    const [listOfBOM, setListOfBOM] = useState({});
    const [bomNameError, setBomNameError] = useState(false);
    const [selectedBom, setSelectedBom] = useState([]);
    const [bomListError, setBomListError] = useState(false);

    const [{ inventoryList }, { }, { }] = useProductInventoryStore();
    const inventory = inventoryList;
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const [{ bom_list }, { fetch_bom_list, get_bom_detail_by_bom_id }, { create_bom, add_part_to_bom }] = useBOMStore();

    const [{ AddToBOMPopup }, { }, { }] = useDOMAttachToSystemStore();
    const FromCart = AddToBOMPopup?.data?.fromCart === 'yes'
    const ERPPartNumber = AddToBOMPopup?.data?.fromCart === 'yes' ? '' : AddToBOMPopup?.data?.single_product?.ERPPartNumber
    const ERPMFRPartNumber = AddToBOMPopup?.data?.fromCart === 'yes' ? '' : AddToBOMPopup?.data?.single_product?.ERPMFRPartNumber
    const ManufacturerPartNumber = AddToBOMPopup?.data?.fromCart === 'yes' ? '' : AddToBOMPopup?.data?.single_product?.ManufacturerPartNumber
    const ItemNumber = AddToBOMPopup?.data?.fromCart === 'yes' ? '' : AddToBOMPopup?.data?.single_product?.ItemNumber
    const Quantity = AddToBOMPopup?.data?.fromCart === 'yes' ? 0 : AddToBOMPopup?.data?.single_product?.Quantity
    const LifeCycleRisk = AddToBOMPopup?.data?.fromCart === 'yes' ? '' : AddToBOMPopup?.data?.single_product?.LifeCycleRisk
    const addFrom = AddToBOMPopup?.data?.addFrom
    let selectedBOMDetails = [];

    useEffect(() => {
        if (AddToBOMPopup) {
            async function fetchHere() {
                await fetch_bom_list()
            }
            if (authLoggedIn()) {
                fetchHere()
            }
            setEnableDisable('bom_list', false)
            setBomNameStatus(true)
            setBomListStatus(true)
            setSelectedBom([])
            SetStatus(true)
        }
    }, [AddToBOMPopup]);
    const onHide = (action = true) => {
        document.body.style.overflow = '';
        SetStatus(false)
    };

    const onBomNameChange = (name) => {
        setBomName(name);
        if (name !== '') {
            setBomListStatus(false);
            setEnableDisable('bom_list', true)
        } else {
            setBomListStatus(true);
            setEnableDisable('bom_list', false)
        }
    }

    useEffect(() => {
        setListOfBOM(optionsAvailable());
    }, [bom_list])

    useEffect(() => {
        filterBomList(optionsSearchInput)
    }, [optionsSearchInput]);

    const optionsAvailable = () => {
        let LinkedWithSystem = {};
        if (Object.entries(bom_list).length > 0) {
            Object.entries(bom_list).map((v, i) => {
                LinkedWithSystem[v[1].bomId] = {
                    bomId: v[1].bomId,
                    bomName: v[1].bomName,
                    isView: true
                };
            });
        }
        return LinkedWithSystem;
    };

    const filterBomList = (param) => {
        let here = optionsAvailable();
        Object.entries(optionsAvailable()).filter((v, i) => {
            if (param &&
                !v[1].bomName.toLowerCase().includes(param.toLowerCase())) {
                here[v[1].bomId].isView = false;
            }
        });
        setListOfBOM(here)
    }

    const setEnableDisable = (elementID, status) => {
        var _container = document.getElementById(elementID);
        if (_container !== null) {
            var _chks = _container.getElementsByTagName("INPUT");
            var _numChks = _chks.length - 1;

            for (var i = 0; i <= _numChks; i++) {
                var _type = _chks[i].getAttribute("type");
                if (_type == "checkbox" && status === false)
                    _chks[i].checked = false;

                if (_type == "checkbox" && status === true)
                    _chks[i].checked = false;

                _chks[i].disabled = status;
            }

            if (status === true) {
                setOptionsSearchInput('');
            }
        }
    }

    const setCheckAll = (check) => {
        var _container = document.getElementById('bom_list');
        if (_container !== null) {
            var _chks = _container.getElementsByTagName("INPUT");
            var _numChks = _chks.length - 1;

            for (var i = 0; i <= _numChks; i++) {
                _chks[i].checked = check;
            }
            setBomNameStatus(!check)
            if (check) {
                if (Object.keys(bom_list).length > 0) {
                    let newBomList = []
                    Object.keys(bom_list).map((v, i) => {
                        newBomList.push(bom_list[v].bomId)
                    });
                    setSelectedBom(newBomList)
                }
            } else {
                setSelectedBom([])
            }
        }
    }

    const onListHandler = (bomId, value) => {
        let newBomList = [...selectedBom];
        if (value === true) {
            newBomList.push(bomId)
            setSelectedBom(newBomList)
        } else {
            var index = newBomList.indexOf(bomId);
            if (index !== -1) {
                newBomList.splice(index, 1);
            }
            setSelectedBom(newBomList)
        }
        if (newBomList.length > 0) {
            setBomNameStatus(false)
        } else {
            setBomNameStatus(true)
        }
    }

    const authLoggedIn = () => {
        return liveAuth.check();
    };

    const onCreateBom = async () => {
        if (bomName === '' || bomName.trim().length === 0) {
            setBomNameError(true)
        } else {
            let params = {}
            params.bomName = bomName
            params.partNumber = ERPPartNumber
            params.ERPPartNumber = ERPPartNumber
            params.ERPMFRPartNumber = ERPMFRPartNumber
            params.quantity = Quantity
            params.fromCart = FromCart
            params.ManufacturerPartNumber = ManufacturerPartNumber
            params.ItemNumber = ItemNumber
            params.LifeCycleRisk = LifeCycleRisk
            params = new CartRepository().attachCustomerPartNumberBeforeServerCall(params);
            params.cpnType = params.cpn ? Constants.cpnTypes.CPN : Constants.cpnTypes.MANUALCPN
            params.manualCPN = ''
            params.source = addFrom
            // if (params.cpn) {
            //     params.cpnType = Constants.cpnTypes.CPN
            // } else {
            //     params.cpnType = Constants.cpnTypes.MANUALCPN
            //     params.manualCPN = ''
            // }

            await create_bom(params).then(async (res) => {
                if (res) {
                    onHide();
                    setBomName('');
                    let resL = await get_bom_detail_by_bom_id({ bomId: res.payload.data });
                    FromCart ? System.alert('Cart is added to ' + `<a onClick="openBOM()" href="${Bom.getBomDetailByIdRouteURL(res.payload.data, { "addFrom": addFrom })}">${resL.payload.bomName}</a>`) :
                        System.alert(params.ERPMFRPartNumber + ' has been added to ' + `<a onClick="openBOM()" href="${Bom.getBomDetailByIdRouteURL(res.payload.data, { "addFrom": addFrom })}">${resL.payload.bomName}</a>`);

                    /**
                     * Set Events and Evars as per basav comment (14664)
                     * Author: Devanshi Patel
                     */
                    if (window?.digitalData) {
                        if (!window?.digitalData?.transaction) {
                            window.digitalData.transaction = {}
                        }
                        window.digitalData.transaction.bomSource = addFrom;
                        window.digitalData.transaction.bomId = resL?.payload?.bomId;
                        window.digitalData.transaction.bomName = resL?.payload?.bomName;
                    }

                    if (window.adobeDataLayer) {
                        selectedBOMDetails = ({ "bomID": resL?.payload?.bomId, "bomName": resL?.payload?.bomName });
                        let eventName = "createBOM";
                        addToBOMEvent(eventName);
                    }
                }
            })
        }
    }
    const onAddPartToBom = async (e) => {
        e.preventDefault()
        if (isArray(selectedBom) && selectedBom.length < 1) {
            setBomListError(true)
        } else {
            setBomListError(false)
            let params = {}
            params.ERPPartNumber = ERPPartNumber
            params.partNumber = ERPMFRPartNumber
            params.ERPMFRPartNumber = ERPMFRPartNumber
            params.quantity = Quantity
            params.bomIds = selectedBom
            params.fromCart = FromCart
            params.ManufacturerPartNumber = ManufacturerPartNumber
            params.ItemNumber = ItemNumber
            let links = '';
            let bomNameWithComa = ''
            let bomIdWithComa = ''
            selectedBom.map((v, i) => {
                bomIdWithComa += (bom_list[v].bomId + ((selectedBom[i + 1] !== undefined && selectedBom[i + 1] !== null) ? ', ' : ''));
                bomNameWithComa += (bom_list[v].bomName + ((selectedBom[i + 1] !== undefined && selectedBom[i + 1] !== null) ? ', ' : ''));
                links += `<a onClick="openBOM()" href="${Bom.getBomDetailByIdRouteURL(v, { "addFrom": addFrom })}">${bom_list[v].bomName}</a>${(selectedBom[i + 1] !== undefined && selectedBom[i + 1] !== null) ? ', ' : ''}`
                selectedBOMDetails = ({ "bomID": bomIdWithComa, "bomName": bomNameWithComa, "source": bom_list[v]?.source });
            });
            params = new CartRepository().attachCustomerPartNumberBeforeServerCall(params);
            params.cpnType = params.cpn ? Constants.cpnTypes.CPN : Constants.cpnTypes.MANUALCPN
            params.manualCPN = ''

            // if (params.cpn) {
            //     params.cpnType = Constants.cpnTypes.CPN
            // } else {
            //     params.cpnType = Constants.cpnTypes.MANUALCPN
            //     params.manualCPN = ''
            // }
            await add_part_to_bom(params).then(async (res) => {
                if (res) {
                    onHide();
                    setSelectedBom([]);
                    FromCart ? System.alert('Cart is added to ' + links) :
                        System.alert(params.ERPMFRPartNumber + ' has been added to ' + links);

                    localStorage.setItem("adobeEventType", "bomOpened");
                    /**
                     * Set Events and Evars as per basav comment (14664)
                     * Author: Devanshi Patel
                     */
                    if (window?.digitalData) {
                        if (!window?.digitalData?.transaction) {
                            window.digitalData.transaction = {}
                        }
                        window.digitalData.transaction.bomSource = addFrom;
                        window.digitalData.transaction.bomId = bomIdWithComa;
                        window.digitalData.transaction.bomName = bomNameWithComa;
                    }
                    if (window.adobeDataLayer) {
                        addToBOMEvent("addToBOM");
                    }
                }
            })
        }
    }

    //By Ramya Kannan [Add to BOM - Adobe script ]
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();

    function addToBOMEvent(evntName) {
        localStorage.setItem("adobeEventType", evntName);
        let prodDetails = isArray(AddToBOMPopup?.data.single_product) ? AddToBOMPopup?.data.single_product : [AddToBOMPopup?.data.single_product];
        let bomDetails = { ...selectedBOMDetails };
        bomDetails.projectId = bomDetails.bomID || bomDetails.projectId;
        bomDetails.newBOM = evntName.toLowerCase() == 'createbom' ? 'Yes' : 'No'
        bomDetails.source = evntName.toLowerCase() == 'createbom' ? addFrom : bomDetails?.source;
        if (bom_project_list) {
            bomDetails.projectName = bom_project_list[(bomDetails.projectId)]?.projectName;
        }
        if (prodDetails.length > 0) {
            prodDetails = prodDetails.map((x) => ({
                ...x,
                qas: AddToBOMPopup?.data.single_product?.qas || 0,
                priceSource: AddToBOMPopup?.data.single_product?.priceSource || ''
            }));
        }
        if (Object.keys(prodDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({
                prodDetails,
                bomDetails,
            });
        }
    }

    //added by Ramya [Adobe script]
    const getInventory = (ERPPartNumber) => {
        if (inventory[ERPPartNumber] !== undefined) {
            return inventory[ERPPartNumber];
        }
        return {
            qas: 0,
            quantity: 0,
        };
    };
    const getPricing = (
        ERPMFRPartNumber,
        ERPPartNumber,
        ERPPartNumberModified
    ) => {
        ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
        if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
            return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
        }
        return [];
    };


    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                {!authLoggedIn() ? System.popup('GuestPopupActionButton', { title: 'BOM Upload', body: 'Sign-in to upload BOM' }) :
                    <div className="avnet-modal modal-600">
                        <div className="avnet-modal-inner">
                            {/* Modal Header */}
                            <button type="button" className="close" data-dismiss="modal"
                                onClick={() => {
                                    onHide()
                                }}>×
                            </button>

                            <div className="modal-header justify-content-center mt-0">
                                <h3 className="pcn-modal-heading">{!authLoggedIn() ? 'BOM Upload' : 'Add to BOM'}</h3>
                            </div>
                            {/* Modal body */}

                            <div className="modal-body">
                                <div className="clearfix" />
                                <div className="bs5 row gx-2">
                                    <div className="col-12">
                                        <div className="">
                                            <label htmlFor="name" className="form-label">Add To New BOM</label>
                                            {bomNameError === true &&
                                                <div className="alert alert-danger fade in font-16 mb-2">
                                                    <span>A name is required to submit a BOM.</span>
                                                    <i className="fa fa-warning ps-2 ms-auto"></i>
                                                </div>
                                            }
                                            {bomListError === true &&
                                                <div className="alert alert-danger fade in font-16 mb-2">
                                                    <span>Please select at least one BOM from drop-down or Create a BOM</span>
                                                    <i className="fa fa-warning ps-2 ms-auto"></i>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col">

                                        <div className="mb-3">
                                            <input type="text"
                                                className={bomNameError === true ? "form-control form-control-sm error" : "form-control form-control-sm"}
                                                id="bom_name" placeholder="BOM NAME"
                                                name="bom_name" value={bomName}
                                                onChange={(e) => onBomNameChange(e.target.value)}
                                                disabled={bomNameStatus !== true} />
                                        </div>
                                    </div>
                                    <div className="col-auto align-self-end">
                                        <div className="mb-3">
                                            <button type="submit" className="bs5 btn btn-primary btn-sm w145"
                                                disabled={bomNameStatus !== true}
                                                onClick={(e) => {
                                                    __check(['BOM_OPERATION_API_CALL']).status ? e.preventDefault() : onCreateBom()
                                                }}>
                                                {__check(['BOM_OPERATION_API_CALL']).status &&
                                                    <>
                                                        <i className="fa fa-spinner fa-spin" />
                                                    </>
                                                }
                                                {!__check(['BOM_OPERATION_API_CALL']).status &&
                                                    <>
                                                        CREATE BOM
                                                    </>
                                                }

                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {__check(['BOM_API_CALL']).render}
                                {!__check(['BOM_API_CALL']).status &&
                                    <div className="light-card m-b-10" id='bom_list'>
                                        <div className="light-card-header dark-card-title">
                                            <div className="light-card-title">
                                                {listOfBOM !== undefined && Object.keys(listOfBOM).length > 0 &&
                                                    <div className="form-check">
                                                        <input type="checkbox" className="form-check-input font-18 " id="check_all"
                                                            name="checkAll"
                                                            checked={Object.keys(listOfBOM).length === selectedBom.length}
                                                            onChange={(e) => {
                                                                setCheckAll(e.target.checked)
                                                            }} />
                                                        <label className="form-check-label ps-0 text-black" htmlFor="column">Your
                                                            BOM’s</label>
                                                    </div>
                                                }
                                            </div>
                                            <div className="light-card-search ms-auto">
                                                <div className="form-group has-search mb-0 font-normal">
                                                    <span className="fa fa-search text-black-stone form-control-feedback" />
                                                    <input type="text" className="form-control mb-0" placeholder="Search BOM’s"
                                                        name="search" value={optionsSearchInput} onChange={(e) => {
                                                            setOptionsSearchInput(e.target.value)
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="light-card-body p-0">
                                            <div className="filter-checkbox-list">
                                                {listOfBOM !== undefined && Object.keys(listOfBOM).length > 0 &&

                                                    Object.keys(listOfBOM).map((v, i) => (
                                                        <div className="form-check" key={v} style={{ display: listOfBOM[v].isView === true ? 'flex' : 'none' }}>
                                                            <input type="checkbox" className="form-check-input font-18"
                                                                id={i + "BOM_Data"}
                                                                name={i + "BOM_Data"}
                                                                onChange={(e) => {
                                                                    onListHandler(listOfBOM[v].bomId, e.target.checked)
                                                                }} />
                                                            <label className="form-check-label text-blue2 font-bold ellipses"
                                                                htmlFor={i + "BOM_Data"} title={listOfBOM[v].bomName}>
                                                                {listOfBOM[v].bomName}</label>
                                                        </div>
                                                    ))
                                                }

                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>

                            {/* Modal footer */}
                            {!__check(['BOM_API_CALL']).status &&
                                <div className="modal-footer text-center">
                                    <div className="modal-footer-actions">

                                        <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-toggle="modal"
                                            data-target="#BomModal"
                                            onClick={() => {
                                                onHide()
                                            }}>
                                            CANCEL
                                        </button>
                                        {authLoggedIn() &&
                                            <button type="button" className="bs5 btn btn-primary btn-sm w145" data-toggle="modal"
                                                data-target="#BomModal"
                                                disabled={bomListStatus === true ? false : true}
                                                onClick={(e) => {
                                                    __check(['BOM_OPERATION_API_CALL']).status ? e.preventDefault() : onAddPartToBom(e)
                                                }}>
                                                {__check(['BOM_OPERATION_API_CALL']).status &&
                                                    <>
                                                        <i className="fa fa-spinner fa-spin" />
                                                    </>
                                                }
                                                {!__check(['BOM_OPERATION_API_CALL']).status &&
                                                    <>
                                                        Done
                                                    </>
                                                }
                                            </button>
                                        }

                                        {!authLoggedIn() &&
                                            <button className="bs5 btn btn-primary btn-sm w145">Sign In
                                            </button>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </Modal>
        </>
    );
}

export default AddToBOMPopup;